import * as yup from 'yup'

{
  /* ひとまず英語にした sakao  */
}
export const deviceLoginIdSchema = yup
  .string()
  .matches(/^[a-zA-Z0-9]{10,}$/, '10_id_alphanumeric_warning')
  .min(10, '10_id_alphanumeric_warning')
  .max(20, '20_id_alphanumeric_warning')
  .required('id_warning')

export const devicePasswordSchema = yup
  .string()
  .matches(/^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]{10,}$/, '10_passward_alphanumeric_warning')
  .min(10, '10_passward_alphanumeric_warning')
  .max(20, '20_passward_alphanumeric_warning')
  .required('passward_warning')

export const apiKeySchema = yup
  .string()
  .matches(/^[\w-]{1,255}$/, '255_api_alphanumeric_warning')
  .required('api_message')

export const serialSchema = yup
  .string()
  .matches(/^[\w]{1,16}$/, '16_serial_number_warning')
  .required('default_initial_settings')
